module.exports = __webpack_public_path__ + "img/panel5.927e58c9.svg";